import { Get } from '../helpers';
import { EventGroupTreeEntry } from '@/types/projects.types';

const GetProjectGroupTree = (
  channel: number
): Promise<{ tree: EventGroupTreeEntry; nameMap: Record<string, string> }> => {
  return Get({
    url: `/v3/admin/channel/${channel}/event-group-tree`,
  });
};

export default GetProjectGroupTree;
